module.exports = __webpack_public_path__ + "img/652b00bcb6bc26bf512816bf1be26c59.652b00bc.png";